import { useStrings } from "@1js/localization-components";
import { Column, Grid, Row } from "@1js/pl-card-components";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";
import { SectionTitle } from "../SectionTitle/SectionTitle.web";
import type { App } from "./AppNavItem.web.data";
import { AppNavList } from "./AppNavList.web";
import { SeeAllButtonLabel } from "./AppNavSection.web.string";

const useStyles = makeStyles({
  viewMoreBtn: {
    color: tokens.colorBrandForeground1,
  },

  footerRow: {
    justifyContent: "center",
  },

  spacing: {
    marginBottom: "32px",
  },
});

export const AppNavSection: React.FC<{
  title: string;
  apps: App[];
}> = ({ apps, title }) => {
  const styles = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [showSeeAll, setShowSeeAll] = React.useState(false);
  const localizations = useStrings({
    SeeAllButtonLabel,
  });

  const handleOnInit = (hasOverflow: boolean) => {
    setShowSeeAll(hasOverflow);
  };

  return (
    <Grid testid="app-nav">
      <Row>
        <Column size={12}>
          <SectionTitle title={title} />
        </Column>
      </Row>
      <Row>
        <Column size={12} className={styles.spacing}>
          <div data-telemetry-parent-id="AppNavSection">
            <AppNavList expanded={expanded} apps={apps} onInit={handleOnInit} />
          </div>
        </Column>
      </Row>
      {showSeeAll && (
        <Row className={styles.footerRow}>
          <Column size="auto">
            <Button
              className={styles.viewMoreBtn}
              size="large"
              appearance="subtle"
              onClick={() => {
                setExpanded((pre) => !pre);
                setShowSeeAll((pre) => !pre);
              }}
              data-testid="app-nav-see-all"
            >
              {localizations.SeeAllButtonLabel()}
            </Button>
          </Column>
        </Row>
      )}
    </Grid>
  );
};
